<template>
  <div>
    <div class="basicBars" :class="{moon: moon}">
      <div class="right">
        <div class="logo">N</div>
        <div class="search">
          <input type="text" placeholder="Search">
        </div>
      </div>
      <div class="left">
        <div class="trash">
          <img src="../assets/img/Trash.svg" alt="">
          <div class="name">
            <img src="../assets/img/add.svg" alt="">
            <span>note</span>
          </div>
        </div>
        <div class="group">
          <img src="../assets/img/Group.svg" alt="">
          <div class="name">
            <img src="../assets/img/add.svg" alt="">
            <span>group</span>
          </div>
        </div>
        <div class="sort">
          <div class="left">
            <img src="../assets/img/List-1.svg" alt="">
          </div>
          <div class="right">
            <img src="../assets/img/List-2.svg" alt="">
          </div>
        </div>
        <div class="modal" @click="changeStyle">
            <img src="../assets/img/night.svg" alt="">
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moon: false
    }
  },
  methods: {
    changeStyle() {
      this.$emit('moon',this.moon =! this.moon)
    }
  }
}
</script>


<style lang="sass">

</style>
